import { cn } from 'utils';

import { RButtonVariants } from '../Loader';

export function getVariantClasses({
  variant,
  variantColor,
  disabled,
  fullWidth,
}) {
  if (variant === RButtonVariants.outline) {
    if (disabled) {
      return 'text-gray-100 bg-gray-50 hover:bg-gray-50 active:bg-gray-50';
    }

    return 'text-gray-950 bg-gray-50 hover:bg-gray-75 active:bg-gray-90';
  }

  if (variant === RButtonVariants.outlineBordered) {
    return cn(
      'border-gray-100 text-gray-950 font-medium rounded-[8px] bg-transparent py-[8px] px-[16px]',
      disabled
        ? 'opacity-30 hover:bg-transparent active:bg-transparent'
        : 'opacity-100 hover:bg-gray-75 active:bg-gray-90'
    );
  }

  if (variant === RButtonVariants.small) {
    return cn(
      'rounded-[8px] text-gray-25 bg-new-purple py-[8px] px-[16px] hover:bg-new-purple hover:opacity-80 active:bg-new-purple active:opacity-100',
      disabled ? 'opacity-30' : 'opacity-100'
    );
  }

  if (variant === RButtonVariants.smallOutlineBordered) {
    return cn(
      'rounded-[8px] bg-transparent py-[8px] px-[16px] font-normal',
      disabled
        ? 'cursor-auto text-[#b3a7ce] border-[#b3a7ce] [&_svg_path]:fill-[#b3a7ce]'
        : 'text-new-purple border-new-purple'
    );
  }

  if (variant === RButtonVariants.text) {
    return cn(
      'bg-white text-[16px] font-medium',
      disabled ? 'text-gray-100' : 'text-gray-950'
    );
  }

  return cn(
    'text-[14px] font-medium text-gray-25 hover:opacity-80',
    disabled ? 'opacity-30' : 'opacity-100',
    !fullWidth && 'py-[11px] px-[24px]',
    variantColor
      ? 'bg-[var(--rbtn-bg)] hover:bg-[var(--rbtn-bg)] active:bg-new-purple'
      : 'bg-new-purple hover:bg-new-purple active:bg-new-purple'
  );
}
